import {Injectable} from '@angular/core';
import {Environment} from '../../shared/environment/environment';
import {HttpClient} from '@angular/common/http';
import {OmapiCharacteristics} from '../../model/omapi-characteristics';
import {map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {OmapiProductResponse} from './OmapiProductResponse';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';

@Injectable()
export class OmapiService {

  constructor(private httpClient: HttpClient) {
  }

  public getWeightForOmapiId(omapiId: string): Observable<OmapiCharacteristics> {
    const omapiURL = this.getOmapiUrl(omapiId);
    return this.httpClient.get<OmapiProductResponse>(omapiURL).pipe(
      map(response => {
        const omapiCharacteristics = new OmapiCharacteristics();
        omapiCharacteristics.weightnl = response.product.characteristics.weightnl;
        omapiCharacteristics.weightfr = response.product.characteristics.weightfr;
        return omapiCharacteristics;
      })
    );
  }

  public getPackWithWeightForOmapiId(pack: TvShopEntertainmentPack): Observable<TvShopEntertainmentPack> {
    return pack ? this.getWeightForOmapiId(pack.omapiId).pipe(
      map(omapiCharacteristics => {
        if (omapiCharacteristics && omapiCharacteristics.weightnl) {
          pack.omapiCharacteristics = omapiCharacteristics;
        } else {
          pack.omapiCharacteristics = new OmapiCharacteristics();
          pack.omapiCharacteristics.weightnl = 0;
          pack.omapiCharacteristics.weightfr = 0;
        }
        return pack;
      })
    ) : of(undefined);
  }

  private getOmapiUrl(omapiId: string) {
    return Environment.environmentConfig().baseApiUrl + '/omapi/public/product/' + omapiId;
  }
}
